import $ from 'jquery'
const $getOfferSubmit = document.getElementById('getOfferSubmit')

if ($getOfferSubmit) {
  const origText = $($getOfferSubmit).text()
  $getOfferSubmit.addEventListener('click', function (e) {
    e.preventDefault()
    let form = document.getElementById('getOffer')
    let formData = new FormData(form)

    let formObject = {}

    formData.forEach((value, key) => {
      formObject[key] = value
    })

    formObject['harbor'] = document.getElementById('harbor').value

    formObject['date'] = document.getElementById('datetimepicker').value

    formObject['tour_duration'] = document.getElementById('tour-time').value

    formObject['total_price'] = document.querySelector(
      '.get-offer__all-fee'
    ).innerText

    formObject['meal_price'] = document.querySelector(
      '.get-offer__meal-fee'
    ).innerText

    formObject['extra_service_price'] = document.querySelector(
      '.get-offer__extra-fee'
    ).innerText

    formObject['rent_price'] =
      document.querySelector('.get-offer__fee').innerText

    formObject['people_count'] =
      document.getElementById('number-of-people').value

    formObject['meal_selection'] = []
    document
      .querySelectorAll('.single-menu__meal-checkbox:checked')
      .forEach((checkbox) => {
        const titleElement = checkbox
          .closest('.single-menu__wrapper')
          ?.querySelector('.single-menu__title')

        const price = checkbox
          .closest('.single-menu__wrapper')
          ?.querySelector('.single-menu__amount')

        const calcPrice = checkbox.getAttribute('data-calc-price')
        let calcPriceText
        if (calcPrice == 0) {
          calcPriceText = `Tek Fiyat`
        } else {
          calcPriceText = `Kişi Başı`
        }

        if (titleElement) {
          formObject['meal_selection'].push({
            name: titleElement.innerText,
            price: price.innerText,
            calc_price: calcPriceText,
          })
        }
      })

    formObject['package_selection'] = []
    document
      .querySelectorAll('.single-menu__packages-checkbox:checked')
      .forEach((checkbox) => {
        const titleElement = checkbox
          .closest('.single-menu__wrapper')
          ?.querySelector('.single-menu__title')

        const price = checkbox
          .closest('.single-menu__wrapper')
          ?.querySelector('.single-menu__amount')

        const calcPrice = checkbox.getAttribute('data-calc-price')
        let calcPriceText
        if (calcPrice == 0) {
          calcPriceText = `Tek Fiyat`
        } else if (calcPrice == 1) {
          calcPriceText = `Saatlik`
        } else {
          calcPriceText = `Kişi Başı`
        }

        if (titleElement) {
          formObject['package_selection'].push({
            name: titleElement.innerText,
            price: price.innerText,
            calc_price: calcPriceText,
          })
        }
      })

    formObject['extra_selection'] = []
    document
      .querySelectorAll('.single-menu__extras-checkbox:checked')
      .forEach((checkbox) => {
        const titleElement = checkbox
          .closest('.single-menu__wrapper')
          ?.querySelector('.single-menu__title')

        const price = checkbox
          .closest('.single-menu__wrapper')
          ?.querySelector('.single-menu__amount')

        const calcPrice = checkbox.getAttribute('data-calc-price')
        let calcPriceText
        if (calcPrice == 0) {
          calcPriceText = `Tek Fiyat`
        } else if (calcPrice == 1) {
          calcPriceText = `Saatlik`
        } else {
          calcPriceText = `Kişi Başı`
        }

        if (titleElement) {
          formObject['extra_selection'].push({
            name: titleElement.innerText,
            price: price.innerText,
            calc_price: calcPriceText,
          })
        }
      })

    $.ajax({
      url: vnObject.ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'vn_offer_form_submit',
        data: formObject,
        nonce: vnObject.nonce,
      },
      beforeSend: () => {
        $($getOfferSubmit).prop('disabled', true)
        $($getOfferSubmit).text('...')
      },
      success: (res) => {
        alert(res.data.message)
      },
      complete: () => {
        $($getOfferSubmit).prop('disabled', false)
        $($getOfferSubmit).text(origText)
      },
    })
  })
}
